export default {
    // //----- Dev
    // apiKey: "AIzaSyC_6gJFxi5u6NLjQzaF5kxZe79B49Gja9c",
    // authDomain: "gifuiz.firebaseapp.com",
    // databaseURL: "https://gifuiz.firebaseio.com",
    // projectId: "gifuiz",
    // storageBucket: "gifuiz.appspot.com",
    // messagingSenderId: "733543139978",
    // appId: "1:733543139978:web:ba4c3cbee6231ab5387b73",
    // measurementId: "G-2FRDHPT6LJ"

    // //----- Production
    apiKey: "AIzaSyARjG1R5upZ17g3rSh2VoCSpzzBxENglI4",
    authDomain: "gif-banana.firebaseapp.com",
    databaseURL: "https://gif-banana.firebaseio.com",
    projectId: "gif-banana",
    storageBucket: "gif-banana.appspot.com",
    messagingSenderId: "840636674667",
    appId: "1:840636674667:web:27d78ab2dbb11dcef0f72e",
    measurementId: "G-3XEF3GTWCB"
}